import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import CustomControl from '../../../../../../../components/global/CustomControl';
import Avatar from '../../../../../../../components/global/Avatar';
import { getAsset } from '../../../../../../../util/assets';
import { AVATAR_SIZE_52 } from '../../../../../../../constants/avatar-sizes';
import { IMAGE_SIZE_CODE } from '../../../../../../../constants/image-size-codes';

const propTypes = {
  circle: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    contacts: PropTypes.shape({
      total: PropTypes.number,
    }),
  }),
  onToggleCircle: PropTypes.func,
  isSelected: PropTypes.bool,
};

const ContactCircleTile = ({ circle, onToggleCircle, isSelected }) => {
  return (
    <a
      href="#"
      className="contact-circle-tile"
      onClick={event => {
        event.preventDefault();
        event.stopPropagation();
        onToggleCircle?.();
      }}
    >
      <div className="mr-1">
        <CustomControl
          id={circle.id}
          type="checkbox"
          checked={isSelected}
          readOnly
        />
      </div>
      <Avatar
        photo={
          circle.asset_image
            ? {
                id: circle.asset_image.id,
                thumbnail_urls: [
                  {
                    size_code: IMAGE_SIZE_CODE.SMALL,
                    url: circle.asset_image.url,
                    width: 1,
                    height: 1,
                  },
                ],
              }
            : {
                thumbnail_urls: [
                  { url: getAsset('/waldo-icon.svg'), width: 0, height: 0 },
                ],
              }
        }
        size={AVATAR_SIZE_52}
        className={circle.asset_image ? '' : 'contact-circle-tile-avatar'}
      />
      <div className="ml-2">
        <h5 className="mb-0">{circle.name}</h5>
        {(circle.contacts?.total ?? 0) > 0 && (
          <p className="mb-0 text-light text-bold text-xs">
            {circle.contacts.total}{' '}
            {pluralize('contact', circle.contacts.total)}
          </p>
        )}
      </div>
    </a>
  );
};

ContactCircleTile.propTypes = propTypes;

export default ContactCircleTile;
